module.exports = __webpack_public_path__ + "img/egebilgi-logo.648022b6.png";